export default "__VITE_ASSET__CUl2wse5__"